import { useState, useEffect, useMemo } from "react";
import { getAllPermissions } from "../utils/permissions";

const usePermissions = (moduleName) => {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "permissions") {
        setVersion((v) => v + 1);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const permissions = useMemo(() => {
    return getAllPermissions(moduleName);
  }, [moduleName, version]);

  return permissions;
};

export default usePermissions;
